import { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { LabelText, WrappingValueText } from '~/components/Fields/LabeledValue';
import { provenanceRows, type ProvenanceInput } from './provenanceRows';

/**
 * How a dataset came to exist, as label/value pairs for a two-column
 * details grid: the connector's record when there is one, otherwise the
 * model that produced it in this session, otherwise "Not recorded".
 */
export default function ProvenanceFields(props: ProvenanceInput) {
    const intl = useIntl();
    return (
        <>
            {provenanceRows(intl, props).map((row) => (
                <Fragment key={row.labelId}>
                    <LabelText>
                        <FormattedMessage id={row.labelId} />
                    </LabelText>
                    <WrappingValueText component="span">
                        {row.value}
                    </WrappingValueText>
                </Fragment>
            ))}
        </>
    );
}
